import { Badge } from "@/modules/shadcn/ui/badge";
import { useTranslation } from "react-i18next";

interface PassedBadgeProps {
  passed: boolean;
}

export const PassedBadge = ({ passed }: PassedBadgeProps) => {
  const { t } = useTranslation(["reports", "common"]);
  return (
    <Badge
      variant={passed ? "secondary" : "destructive"}
      className={passed ? "bg-emerald-500/10 text-emerald-700" : undefined}
    >
      {passed ? t("result.passed") : t("result.failed")}
    </Badge>
  );
};
